import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';

const CollectionsUIContext = createContext();
const { initialFilter } = UIHelpers();

export function useCollectionsUIContext () {
    return useContext(CollectionsUIContext);
}

export const CollectionsUIConsumer = CollectionsUIContext.Transaction;

export function CollectionsUIProvider ({ transactionsUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const collection = {};

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        collection
    };

    return <CollectionsUIContext.Provider value={value}>{children}</CollectionsUIContext.Provider>;
}
